import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, ShoppingCart, Globe } from "lucide-react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative pt-20 pb-16 bg-gradient-to-br from-slate-50 to-gray-100 overflow-hidden">
      <div className="absolute inset-0 opacity-60">
        <div className="w-full h-full bg-slate-100/20" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f1f5f9' fill-opacity='0.4'%3E%3Ccircle cx='10' cy='10' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
            Votre partenaire de confiance pour l'
            <span className="text-emerald-600">import-export</span>
          </h1>
          
          <p className="text-lg sm:text-xl text-slate-600 mb-8 max-w-2xl mx-auto leading-relaxed">
            SHADOWTACT SARL vous propose une large gamme de produits électroniques, 
            ménagers, vêtements et articles de première nécessité. Basée à Rennes, 
            notre expertise en commerce international garantit qualité et fiabilité.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link to="/contact">
              <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 text-lg group">
                Nous contacter
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-slate-300 text-slate-700 hover:bg-slate-50 px-8 py-3 text-lg"
            >
              <ShoppingCart className="w-5 h-5 mr-2" />
              Découvrir nos produits
            </Button>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-8 text-sm text-slate-500">
            <div className="flex items-center">
              <Globe className="w-4 h-4 mr-2 text-emerald-600" />
              Import-Export International
            </div>
            <div className="flex items-center">
              <ShoppingCart className="w-4 h-4 mr-2 text-emerald-600" />
              Vente en ligne
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 mr-2 bg-emerald-600 rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>
              Basée à Rennes
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;